(function(){
  'use strict';
  window.dispatchEvent(new Event("core:finished"));
})();